module.exports = __webpack_public_path__ + "img/gift.91b89ef1.png";